import '../styles/map-sidebar.css'
import React from 'react';

import LayerPicker from './LayerPicker';
import MapLegend from './legend';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';

import { Tabs, Tab, ThemeProvider, createTheme, Box } from '@mui/material';

import { paletteColors } from '../constants';

const animationLength = 1000; // This is the length of the animation in milliseconds for the sidebar to open or close. We use this to change the state of the sidebar. This way there is no repeated animation or animation when the app is first loaded.

class CollapsableSidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mode: "open",
            selectedTab: "layers"
        }

        this.tabTheme = createTheme({
            palette: {
                primary: {
                    main: paletteColors.white,
                },
                secondary: {
                    main: paletteColors.white
                }
            },
            typography: {
                useNextVariants: true
            },
        });

        this.contentTheme = createTheme({
            palette: {
                primary: {
                    main: paletteColors.hotBologonese,
                    contrastText: paletteColors.white
                },
                secondary: {
                    main: paletteColors.white
                }
            },
            typography: {
                useNextVariants: true
            }
        });
    }

    handleTabChange = (event, value) => {
        this.setState({ selectedTab: value });
    }

    getContent = () => {
        if (this.state.selectedTab === "layers") {
            return ( 
                <LayerPicker categories={this.props.categories} />
            );
        } else if(this.state.selectedTab === "legend") {
            return (<MapLegend categories={this.props.categories} />);
        }
        else {
            return (<div><p>No Content for "{this.state.selectedTab}"</p></div>);
        }
    }

    closeSidebar = () => {
        this.setState({mode: "closing"});
        setTimeout(() => {
            this.setState({mode: "closed"});
        }, animationLength);
    }

    openSidebar = () => {
        this.setState({mode: "opening"});
        setTimeout(() => {
            this.setState({mode: "open"});
        }, animationLength);
    }


    handleCollapseOpen = () => {
        if(this.state.mode === "closed") {
            this.openSidebar();
        }
        else if(this.state.mode === "opening") {
            this.setState({mode: "open"});
        }
        else if(this.state.mode === "open") {
            this.closeSidebar();
        }
        else if(this.state.mode === "closing") {
            this.setState({mode: "closed"});
        }
    }

    render() {
        let classname = 'MapLayers no-print';
        if(this.state.mode === "open") {
            classname += ' open';
        } else if (this.state.mode === "closed") {
            classname += ' closed';
        } else if (this.state.mode === "opening") {
            classname += ' opening';
        } else if (this.state.mode === "closing") {
            classname += ' closing';
        }

        return (
            <div className={classname}>
                <div className='sidebar-content'>
                    <ThemeProvider theme={this.tabTheme}>
                    <Tabs value={this.state.selectedTab} onChange={this.handleTabChange} aria-label="basic tabs example" centered textColor="inherit" indicatorColor='secondary' >
                        <Tab label="Layers" value="layers" />
                        <Tab label="Legend" value="legend" />
                    </Tabs>
                    </ThemeProvider>

                    <ThemeProvider theme={this.contentTheme}>
                    
                    <div className='sidebar-content-content'>
                        {this.getContent()}
                    </div>

                    </ThemeProvider>
                </div>
                
                <button className='collapse-open-tab' onClick={this.handleCollapseOpen} >
                    <FontAwesomeIcon icon={faLayerGroup} className="tibbytab-icon" />
                </button>
            </div>
            );
    }
}

export default CollapsableSidebar;